/* UKLISS v15 homepage behaviors
   - Header: transparent over hero → frosted white on scroll (TYMO behavior)
   - Locale dropdowns
   - Drag-to-scroll for talks / blog / press rails
   - Blog carousel pagination dots
   - Press & reviews arrows
   - Hair Talks inline muted playback (play / pause / close)
*/
(function () {
  'use strict';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Header scroll state ---------- */
  (function headerState() {
    var header = document.querySelector('[data-v15-header]');
    if (!header) return;
    var anno = document.querySelector('.anno3');
    var ticking = false;
    function annoH() { return anno ? anno.getBoundingClientRect().height : 0; }
    function update() {
      ticking = false;
      var a = annoH();
      var y = window.scrollY || window.pageYOffset || 0;
      header.style.top = Math.max(0, a - y) + 'px';
      header.classList.toggle('is-solid', y > a - 4);
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    window.addEventListener('resize', update);
    update();

    /* mega-open keeps the bar solid (global.js toggles panels; observe) */
    var observer = new MutationObserver(function () {
      header.classList.toggle('is-mega-open', !!header.querySelector('.v15mega.is-open'));
    });
    header.querySelectorAll('.v15mega').forEach(function (p) {
      observer.observe(p, { attributes: true, attributeFilter: ['class'] });
    });
  })();

  /* ---------- Locale dropdowns ---------- */
  document.querySelectorAll('[data-loc-toggle]').forEach(function (btn) {
    var menu = btn.nextElementSibling;
    if (!menu) return;
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var open = !menu.hidden;
      document.querySelectorAll('.v15hdr__locmenu').forEach(function (m) { m.hidden = true; });
      document.querySelectorAll('[data-loc-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      menu.hidden = open;
      btn.setAttribute('aria-expanded', String(!open));
    });
  });
  document.addEventListener('click', function () {
    document.querySelectorAll('.v15hdr__locmenu').forEach(function (m) { m.hidden = true; });
    document.querySelectorAll('[data-loc-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  });

  /* ---------- Generic drag-to-scroll ---------- */
  /* Snap stops of a rail: each child of the track that declares a
     scroll-snap-align, measured in scrollLeft units (minus scroll-padding). */
  function snapStops(vp) {
    var track = vp.firstElementChild;
    if (!track) return [];
    var pad = parseFloat(getComputedStyle(vp).scrollPaddingLeft) || 0;
    var vr = vp.getBoundingClientRect();
    var max = vp.scrollWidth - vp.clientWidth;
    var stops = [];
    Array.prototype.forEach.call(track.children, function (c) {
      if (getComputedStyle(c).scrollSnapAlign === 'none') return;
      var x = c.getBoundingClientRect().left - vr.left + vp.scrollLeft - pad;
      stops.push(Math.max(0, Math.min(max, Math.round(x))));
    });
    if (stops.indexOf(max) === -1) stops.push(max);
    return stops.sort(function (a, b) { return a - b; });
  }

  /* Ease the rail to `target` with snapping off, then hand snapping back.
     Snapping stays off during the glide, otherwise the browser would jump
     straight to the stop on the first frame (the "一帧跳变" reported). */
  function glide(vp, target) {
    var from = vp.scrollLeft, dist = target - from;
    if (vp._glide) cancelAnimationFrame(vp._glide);
    if (Math.abs(dist) < 1 || reduceMotion) {
      vp.scrollLeft = target; vp.style.scrollSnapType = ''; return;
    }
    var dur = Math.min(520, Math.max(260, Math.abs(dist) * 0.9)), t0 = null;
    function frame(t) {
      if (t0 === null) t0 = t;
      var k = Math.min(1, (t - t0) / dur);
      var e = 1 - Math.pow(1 - k, 3); // easeOutCubic
      vp.scrollLeft = from + dist * e;
      if (k < 1) { vp._glide = requestAnimationFrame(frame); }
      else { vp._glide = null; vp.scrollLeft = target; vp.style.scrollSnapType = ''; }
    }
    vp._glide = requestAnimationFrame(frame);
  }

  function bindDrag(vp) {
    var down = false, startX = 0, startLeft = 0, moved = 0;
    var lastX = 0, lastT = 0, vel = 0; // px per ms, positive = content moving left
    /* Capture the pointer only once the mouse has actually dragged. Capturing
       on pointerdown retargets the click to the viewport itself, so buttons
       inside the rail (Hair Talks play) never received it on desktop. */
    vp.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      if (vp._glide) { cancelAnimationFrame(vp._glide); vp._glide = null; }
      down = true; moved = 0; startX = lastX = e.clientX; startLeft = vp.scrollLeft;
      lastT = performance.now(); vel = 0;
    });
    vp.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      moved = Math.max(moved, Math.abs(dx));
      var now = performance.now(), dt = now - lastT;
      if (dt > 0) vel = 0.8 * ((lastX - e.clientX) / dt) + 0.2 * vel;
      lastX = e.clientX; lastT = now;
      if (Math.abs(dx) > 4) {
        if (!vp.classList.contains('is-dragging')) {
          vp.classList.add('is-dragging');
          vp.style.scrollSnapType = 'none';
          try { vp.setPointerCapture(e.pointerId); } catch (err) {}
        }
        vp.scrollLeft = startLeft - dx;
      }
    });
    function end(e) {
      if (!down) return;
      down = false;
      if (vp.hasPointerCapture && e.pointerId != null && vp.hasPointerCapture(e.pointerId)) vp.releasePointerCapture(e.pointerId);
      var wasDragging = vp.classList.contains('is-dragging');
      setTimeout(function () { vp.classList.remove('is-dragging'); }, 0);
      if (!wasDragging) return;
      /* Settle on a whole card with an eased glide instead of letting the
         browser snap in one frame. A quick flick carries on to the next
         stop in the drag direction; a slow release goes to the nearest. */
      if (performance.now() - lastT > 90) vel = 0;
      var stops = snapStops(vp);
      if (!stops.length) { vp.style.scrollSnapType = ''; return; }
      var cur = vp.scrollLeft, target = stops[0];
      if (Math.abs(vel) > 0.35) {
        var i;
        if (vel > 0) { target = stops[stops.length - 1]; for (i = 0; i < stops.length; i++) if (stops[i] > cur + 2) { target = stops[i]; break; } }
        else { target = stops[0]; for (i = stops.length - 1; i >= 0; i--) if (stops[i] < cur - 2) { target = stops[i]; break; } }
      } else {
        stops.forEach(function (x) { if (Math.abs(x - cur) < Math.abs(target - cur)) target = x; });
      }
      glide(vp, target);
    }
    /* Without pointer capture on pointerdown, a drag that starts on a poster
       image would begin a native image drag and cancel the pointer stream. */
    vp.addEventListener('dragstart', function (e) { e.preventDefault(); });
    vp.addEventListener('pointerup', end);
    vp.addEventListener('pointercancel', end);
    vp.addEventListener('click', function (e) {
      if (moved > 6) { e.preventDefault(); e.stopPropagation(); moved = 0; }
    }, true);
  }
  document.querySelectorAll('[data-talks-viewport], [data-blog-viewport], [data-press-viewport], [data-conf-viewport]').forEach(bindDrag);

  /* ---------- Blog carousel dots ---------- */
  document.querySelectorAll('[data-v15-blog]').forEach(function (root) {
    var vp = root.querySelector('[data-blog-viewport]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-blog-dot]'));
    if (!vp || !dots.length) return;
    var cards = Array.prototype.slice.call(vp.querySelectorAll('.v15blog__card'));

    function padLeft() {
      var track = vp.querySelector('.v15blog__track');
      return track ? parseFloat(getComputedStyle(track).paddingLeft) || 0 : 0;
    }
    function cardStart(c) {
      // card left within the scroller (offsetLeft is unreliable once the
      // viewport itself is a centered capped box)
      return vp.scrollLeft + c.getBoundingClientRect().left - vp.getBoundingClientRect().left;
    }
    function activeIndex() {
      // left-anchored: the card whose left edge sits on the section edge line
      var target = vp.scrollLeft + padLeft();
      var best = 0, bestDist = Infinity;
      cards.forEach(function (c, i) {
        var d = Math.abs(cardStart(c) - target);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      return best;
    }
    function sync() {
      var idx = activeIndex();
      dots.forEach(function (d, i) { d.setAttribute('aria-selected', String(i === idx)); });
    }
    function perView() {
      var c = cards[0];
      if (!c) return 1;
      var gap = 32;
      var w = c.getBoundingClientRect().width;
      return Math.max(1, Math.round((vp.clientWidth - padLeft() * 2 + gap) / (w + gap)));
    }
    function refreshDots() {
      // with N cards per view, start positions beyond cards.length - N are
      // unreachable — hide their dots so every dot is a real, clean stop
      var maxStart = Math.max(0, cards.length - perView());
      dots.forEach(function (d, i) { d.hidden = i > maxStart; });
    }
    var t;
    vp.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(sync, 80); }, { passive: true });
    window.addEventListener('resize', refreshDots);
    refreshDots();
    dots.forEach(function (d, i) {
      d.addEventListener('click', function () {
        var c = cards[i];
        if (!c) return;
        vp.scrollTo({ left: Math.max(0, cardStart(c) - padLeft()), behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    });
    sync();
  });

  /* ---------- Press & reviews arrows ---------- */
  document.querySelectorAll('[data-v15-press]').forEach(function (root) {
    var vp = root.querySelector('[data-press-viewport]');
    if (!vp) return;
    function step() {
      // fractional width: offsetWidth rounds and drifts a few px per click
      var card = vp.querySelector('.v15press__card');
      return card ? card.getBoundingClientRect().width + 32 : 540;
    }
    var prev = root.querySelector('[data-press-prev]');
    var next = root.querySelector('[data-press-next]');
    if (prev) prev.addEventListener('click', function () { vp.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
    if (next) next.addEventListener('click', function () { vp.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
  });

  /* ---------- Hair Talks inline playback ---------- */
  document.querySelectorAll('[data-v15-talks]').forEach(function (root) {
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-talk-card]'));

    /* Arrows: one card per click; disabled at either end. */
    var tvp = root.querySelector('[data-talks-viewport]');
    var tprev = root.querySelector('[data-talks-prev]');
    var tnext = root.querySelector('[data-talks-next]');
    function tstep() {
      var c = cards[0];
      if (!c) return 300;
      var gap = parseFloat(getComputedStyle(c.parentElement).columnGap) || 0;
      return c.getBoundingClientRect().width + gap;
    }
    function tsync() {
      if (!tvp) return;
      var max = tvp.scrollWidth - tvp.clientWidth;
      if (tprev) tprev.disabled = tvp.scrollLeft <= 2;
      if (tnext) tnext.disabled = tvp.scrollLeft >= max - 2;
    }
    if (tvp) {
      if (tprev) tprev.addEventListener('click', function () { tvp.scrollBy({ left: -tstep(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
      if (tnext) tnext.addEventListener('click', function () { tvp.scrollBy({ left: tstep(), behavior: reduceMotion ? 'auto' : 'smooth' }); });
      tvp.addEventListener('scroll', tsync, { passive: true });
      window.addEventListener('resize', tsync);
      tsync();
    }

    function setPauseIcon(card, paused) {
      var btn = card.querySelector('[data-talk-pause]');
      if (!btn) return;
      btn.querySelector('[data-icon-pause]').toggleAttribute('hidden', paused);
      btn.querySelector('[data-icon-play]').toggleAttribute('hidden', !paused);
      btn.setAttribute('aria-label', paused ? 'Play' : 'Pause');
    }
    /* SVG elements have no .hidden property — toggle the attribute. */
    function setSoundIcon(card, muted) {
      var btn = card.querySelector('[data-talk-sound]');
      if (!btn) return;
      btn.querySelector('[data-icon-muted]').toggleAttribute('hidden', !muted);
      btn.querySelector('[data-icon-sound]').toggleAttribute('hidden', muted);
      btn.setAttribute('aria-pressed', muted ? 'false' : 'true');
      btn.setAttribute('aria-label', muted ? 'Unmute' : 'Mute');
    }
    function setProgress(card, ratio) {
      var bar = card.querySelector('[data-talk-progress]');
      if (!bar) return;
      var pct = Math.max(0, Math.min(1, ratio || 0)) * 100;
      bar.querySelector('i').style.width = pct + '%';
      bar.setAttribute('aria-valuenow', Math.round(pct));
    }

    function closeCard(card) {
      var video = card.querySelector('video');
      if (video) { video.pause(); video.remove(); }
      card.classList.remove('is-playing', 'is-paused');
      var controls = card.querySelector('.v15talks__controls');
      var closeBtn = card.querySelector('[data-talk-close]');
      if (controls) controls.hidden = true;
      if (closeBtn) closeBtn.hidden = true;
      setPauseIcon(card, false);
      setSoundIcon(card, true);
      setProgress(card, 0);
    }

    cards.forEach(function (card) {
      var play = card.querySelector('[data-talk-play]');
      var tpl = card.querySelector('template[data-talk-video]');
      if (!play || !tpl) return;
      var controls = card.querySelector('.v15talks__controls');
      var pauseBtn = card.querySelector('[data-talk-pause]');
      var closeBtn = card.querySelector('[data-talk-close]');
      var soundBtn = card.querySelector('[data-talk-sound]');
      var bar = card.querySelector('[data-talk-progress]');

      play.addEventListener('click', function () {
        cards.forEach(function (c) { if (c !== card) closeCard(c); });
        card.insertBefore(tpl.content.cloneNode(true), play);
        var video = card.querySelector('video');
        if (video) {
          video.muted = true;
          video.setAttribute('playsinline', '');
          video.addEventListener('timeupdate', function () {
            if (video.duration) setProgress(card, video.currentTime / video.duration);
          });
          video.addEventListener('play', function () { card.classList.remove('is-paused'); setPauseIcon(card, false); });
          video.addEventListener('pause', function () { card.classList.add('is-paused'); setPauseIcon(card, true); });
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        }
        card.classList.add('is-playing');
        if (controls) controls.hidden = false;
        if (closeBtn) closeBtn.hidden = false;
        setSoundIcon(card, true);
        if (pauseBtn) pauseBtn.focus({ preventScroll: true });
      });

      if (soundBtn) soundBtn.addEventListener('click', function () {
        var video = card.querySelector('video');
        if (!video) return;
        video.muted = !video.muted;
        setSoundIcon(card, video.muted);
      });

      if (pauseBtn) pauseBtn.addEventListener('click', function () {
        var video = card.querySelector('video');
        if (!video) return;
        if (video.paused) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
        else video.pause();
      });

      if (bar) {
        function seekTo(ratio) {
          var video = card.querySelector('video');
          if (!video || !video.duration) return;
          video.currentTime = Math.max(0, Math.min(1, ratio)) * video.duration;
          setProgress(card, ratio);
        }
        bar.addEventListener('click', function (e) {
          var r = bar.getBoundingClientRect();
          seekTo((e.clientX - r.left) / r.width);
        });
        bar.addEventListener('keydown', function (e) {
          var video = card.querySelector('video');
          if (!video || !video.duration) return;
          var d = e.key === 'ArrowRight' ? 5 : e.key === 'ArrowLeft' ? -5 : 0;
          if (!d) return;
          e.preventDefault();
          seekTo((video.currentTime + d) / video.duration);
        });
      }

      if (closeBtn) closeBtn.addEventListener('click', function () { closeCard(card); play.focus({ preventScroll: true }); });
    });
  });
})();

/* =========================================================
   v15 PDP — gallery, variants, qty, buy-now, videos, reviews
   ========================================================= */
(function () {
  'use strict';

  /* ---------- Purchase module ---------- */
  document.querySelectorAll('[data-v15-pdp]').forEach(function (root) {
    var stage = root.querySelector('[data-pdp-stage]');
    var track = root.querySelector('[data-pdp-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-thumb]'));
    var current = root.querySelector('[data-pdp-current]');

    function pad(n) { return (n < 9 ? '0' : '') + (n + 1); }

    function setActive(i) {
      if (current) current.textContent = pad(i);
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      var active = thumbs[i];
      if (active && active.scrollIntoView) {
        active.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }
    }

    function goTo(i) {
      if (!track || !slides[i]) return;
      track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
      setActive(i);
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { goTo(parseInt(t.dataset.index, 10) || 0); });
    });

    /* Thumb strip paging — without it the images past the visible ones are
       unreachable on desktop (the strip scrolls but has no drag or scrollbar). */
    var strip = root.querySelector('[data-pdp-thumbs]');
    var tPrev = root.querySelector('[data-pdp-tprev]');
    var tNext = root.querySelector('[data-pdp-tnext]');

    function syncArrows() {
      if (!strip || !tPrev || !tNext) return;
      var scrollable = strip.scrollWidth - strip.clientWidth > 2;
      tPrev.hidden = !scrollable;
      tNext.hidden = !scrollable;
      if (!scrollable) return;
      tPrev.disabled = strip.scrollLeft <= 2;
      tNext.disabled = strip.scrollLeft >= strip.scrollWidth - strip.clientWidth - 2;
    }

    if (strip && tPrev && tNext) {
      var page = function () {
        var first = thumbs[0];
        var step = first ? first.getBoundingClientRect().width + 16 : 120;
        return Math.max(step, Math.floor(strip.clientWidth / step) * step);
      };
      tPrev.addEventListener('click', function () {
        strip.scrollBy({ left: -page(), behavior: 'smooth' });
      });
      tNext.addEventListener('click', function () {
        strip.scrollBy({ left: page(), behavior: 'smooth' });
      });
      strip.addEventListener('scroll', syncArrows, { passive: true });
      window.addEventListener('resize', syncArrows);
      syncArrows();
      window.addEventListener('load', syncArrows);
    }

    if (track) {
      var scrollT = null;
      track.addEventListener('scroll', function () {
        clearTimeout(scrollT);
        scrollT = setTimeout(function () {
          var i = Math.round(track.scrollLeft / track.clientWidth);
          i = Math.max(0, Math.min(slides.length - 1, i));
          setActive(i);
        }, 80);
      }, { passive: true });
    }

    if (stage) {
      stage.addEventListener('keydown', function (e) {
        var i = current ? parseInt(current.textContent, 10) - 1 : 0;
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(Math.min(slides.length - 1, i + 1)); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(Math.max(0, i - 1)); }
      });
    }

    /* Rating badge → reviews. Judge.me renders the badge asynchronously, so
       the click is delegated from the wrapper rather than bound to the badge. */
    var ratingLink = root.querySelector('[data-pdp-ratinglink]');
    if (ratingLink) {
      ratingLink.style.cursor = 'pointer';
      ratingLink.addEventListener('click', function (e) {
        var target = document.getElementById('reviews') ||
                     document.getElementById('judgeme_product_reviews');
        if (!target) return;
        e.preventDefault();
        var header = document.querySelector('.v15hdr, .v15hdr__bar, header');
        var hh = header ? header.getBoundingClientRect().height : 0;
        var offset = Math.max(hh, 100) + 16;

        function land(smooth) {
          var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
          window.scrollTo({ top: top, behavior: smooth ? 'smooth' : 'auto' });
        }
        land(true);
        /* The widget renders lazily and shifts the page under us, so correct
           once it has settled. */
        setTimeout(function () {
          if (Math.abs(target.getBoundingClientRect().top - offset) > 40) land(false);
        }, 900);
      });
    }

    /* Variants */
    var variants = [];
    var dataEl = root.querySelector('[data-pdp-variants]');
    try { variants = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch (err) { variants = []; }

    var idInput = root.querySelector('[data-pdp-variant-id]');
    var priceEl = root.querySelector('[data-pdp-price]');
    var colorLabel = root.querySelector('[data-pdp-color-label]');
    var addBtn = root.querySelector('[data-pdp-add]');
    var buyBtn = root.querySelector('[data-pdp-buynow]');
    var addLabel = addBtn ? addBtn.textContent.trim() : '';

    root.querySelectorAll('[data-pdp-swatch]').forEach(function (sw) {
      sw.addEventListener('click', function () {
        var value = sw.dataset.value;
        var v = null;
        for (var k = 0; k < variants.length; k++) {
          if (variants[k].option1 === value) { v = variants[k]; break; }
        }
        if (!v) return;

        root.querySelectorAll('[data-pdp-swatch]').forEach(function (b) {
          var on = b === sw;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-checked', on ? 'true' : 'false');
        });
        if (colorLabel) colorLabel.textContent = value.toUpperCase();
        if (idInput) idInput.value = v.id;
        if (priceEl) {
          var html = v.price;
          if (v.compare_raw > v.price_raw) html += ' <s>' + v.compare + '</s>';
          priceEl.innerHTML = html;
        }
        if (addBtn) { addBtn.disabled = !v.available; if (v.available) addBtn.textContent = addLabel; }
        if (buyBtn) buyBtn.disabled = !v.available;

        if (v.media_id) {
          for (var i = 0; i < slides.length; i++) {
            if (slides[i].dataset.mediaId === String(v.media_id)) { goTo(i); break; }
          }
        }
      });
    });

    /* Quantity */
    var qtyInput = root.querySelector('[data-pdp-qty-input]');
    root.querySelectorAll('[data-pdp-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qtyInput) return;
        var next = (parseInt(qtyInput.value, 10) || 1) + parseInt(btn.dataset.pdpQty, 10);
        qtyInput.value = Math.max(1, next);
      });
    });

    /* Buy it now → straight to checkout via return_to */
    var returnTo = root.querySelector('[data-pdp-return]');
    if (buyBtn && returnTo) {
      buyBtn.addEventListener('click', function () {
        returnTo.disabled = false;
        returnTo.value = '/checkout';
      });
    }
    if (addBtn && returnTo) {
      addBtn.addEventListener('click', function () {
        returnTo.disabled = true;
        returnTo.value = '';
      });
    }
  });

  /* ---------- Product videos: inline playback, one at a time ---------- */
  document.querySelectorAll('[data-v15-videos]').forEach(function (root) {
    var players = [];
    function pauseOthers(except) {
      players.forEach(function (p) { if (p !== except && !p.paused) p.pause(); });
    }
    root.querySelectorAll('[data-vid-open]').forEach(function (stageBtn) {
      stageBtn.addEventListener('click', function () {
        if (stageBtn.classList.contains('is-playing')) return;
        var url = stageBtn.dataset.videoUrl;
        if (!url) return;
        var video = document.createElement('video');
        video.src = url;
        video.controls = true;
        video.playsInline = true;
        video.setAttribute('playsinline', '');
        video.preload = 'auto';
        var poster = stageBtn.querySelector('.v15vid__poster');
        if (poster) poster.replaceWith(video); else stageBtn.appendChild(video);
        stageBtn.classList.add('is-playing');
        players.push(video);
        video.addEventListener('play', function () { pauseOthers(video); });
        pauseOthers(video);
        video.play();
      });
    });

    /* Mobile rail: one card per screen, arrows page through it. */
    var rail = root.querySelector('[data-vid-rail]');
    var vPrev = root.querySelector('[data-vid-prev]');
    var vNext = root.querySelector('[data-vid-next]');
    if (rail && vPrev && vNext) {
      var cards = Array.prototype.slice.call(rail.querySelectorAll('[data-vid-card]'));

      function railActive() {
        /* Nearest card to the rail's left edge — the gap is a CSS value, so
           measure the real positions rather than assuming a step size. */
        var origin = rail.getBoundingClientRect().left;
        var best = 0, bestD = Infinity;
        cards.forEach(function (c, i) {
          var d = Math.abs(c.getBoundingClientRect().left - origin);
          if (d < bestD) { bestD = d; best = i; }
        });
        return best;
      }
      function syncVidArrows() {
        var scrollable = rail.scrollWidth - rail.clientWidth > 2;
        vPrev.disabled = !scrollable || rail.scrollLeft <= 2;
        vNext.disabled = !scrollable || rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2;
      }
      function page(dir) {
        var i = Math.min(cards.length - 1, Math.max(0, railActive() + dir));
        var card = cards[i];
        if (!card) return;
        /* scrollIntoView honours the rail's scroll-padding; a manual
           scrollTo would land a gutter's width off. */
        card.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      }
      vPrev.addEventListener('click', function () { page(-1); });
      vNext.addEventListener('click', function () { page(1); });

      var vidT = null;
      rail.addEventListener('scroll', function () {
        syncVidArrows();
        /* A video left playing off-screen keeps talking; stop it. */
        clearTimeout(vidT);
        vidT = setTimeout(function () {
          var mid = rail.getBoundingClientRect().left + rail.clientWidth / 2;
          cards.forEach(function (c) {
            var r = c.getBoundingClientRect();
            if (mid < r.left || mid > r.right) {
              var v = c.querySelector('video');
              if (v && !v.paused) v.pause();
            }
          });
        }, 140);
      }, { passive: true });
      window.addEventListener('resize', syncVidArrows);
      syncVidArrows();
    }
  });

  /* ---------- Reviews: reveal the full list ---------- */
  document.querySelectorAll('[data-v15-reviews]').forEach(function (root) {
    var btn = root.querySelector('[data-rev-toggle]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var open = root.classList.toggle('v15rev--open');
      btn.textContent = open ? btn.dataset.lessLabel : btn.dataset.moreLabel;
    });
  });
})();

/* =========================================================
   v15 content pages — policy tabs + contact route shortcuts
   ========================================================= */
(function () {
  'use strict';

  /* Policy library: index swaps the visible panel */
  document.querySelectorAll('[data-policy-library]').forEach(function (root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-policy-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-policy-panel]'));
    function show(id) {
      tabs.forEach(function (t) {
        var on = t.dataset.policyTab === id;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (p) { p.classList.toggle('is-hidden', p.dataset.policyPanel !== id); });
    }
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        show(t.dataset.policyTab);
        if (history.replaceState) history.replaceState(null, '', '#' + t.dataset.policyTab);
      });
    });
    var hash = window.location.hash.replace('#', '');
    if (hash && tabs.some(function (t) { return t.dataset.policyTab === hash; })) {
      show(hash);
      window.requestAnimationFrame(function () { root.scrollIntoView({ block: 'start' }); });
    }
  });

  /* Contact routes: jump to the form and preselect the topic */
  var topicSelect = document.querySelector('[data-contact-topic]');
  document.querySelectorAll('[data-route-topic]').forEach(function (card) {
    card.addEventListener('click', function () {
      if (!topicSelect) return;
      var value = card.dataset.routeTopic;
      for (var i = 0; i < topicSelect.options.length; i++) {
        if (topicSelect.options[i].value === value) { topicSelect.selectedIndex = i; break; }
      }
      topicSelect.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
})();

/* =========================================================
   v16 · Brand introduction — rotating promise cards
   ========================================================= */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-bi-stack]').forEach(function (stack) {
    var cards = Array.prototype.slice.call(stack.querySelectorAll('[data-bi-card]'));
    if (cards.length < 2) return;

    var n = cards.length;
    var front = 0;
    var timer = null;
    var paused = false;
    var interval = parseInt(stack.dataset.interval, 10) || 3000;
    var EXIT = 640; /* keep in step with the CSS transition duration */

    function paint() {
      cards.forEach(function (card, i) {
        var depth = (i - front + n) % n;
        card.dataset.depth = String(Math.min(depth, 3));
        card.setAttribute('aria-hidden', depth === 0 ? 'false' : 'true');
      });
    }

    function advance() {
      var leaving = cards[front];
      leaving.classList.add('is-out');
      front = (front + 1) % n;
      paint();
      /* Once it has drifted off, drop it to the back of the stack in a single
         frame — with the transition suppressed, so it doesn't slide back. */
      setTimeout(function () {
        leaving.classList.add('no-anim');
        leaving.classList.remove('is-out');
        void leaving.offsetWidth;
        leaving.classList.remove('no-anim');
      }, EXIT);
    }

    function start() {
      if (timer || reduce || paused) return;
      timer = setInterval(advance, interval);
    }
    function stop() {
      if (!timer) return;
      clearInterval(timer);
      timer = null;
    }

    paint();

    /* Let people finish reading a card. */
    stack.addEventListener('mouseenter', function () { paused = true; stop(); });
    stack.addEventListener('mouseleave', function () { paused = false; start(); });
    stack.addEventListener('focusin', function () { paused = true; stop(); });
    stack.addEventListener('focusout', function () { paused = false; start(); });

    /* Only run while the band is actually on screen. */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) start(); else stop(); });
      }, { threshold: 0.2 }).observe(stack);
    } else {
      start();
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });
  });
})();

/* ============================================================
   Hero image carousel (v15-hero-slides)
   Cross-fade, autoplay, arrows, dots, swipe. Autoplay pauses on
   hover/focus, when the hero scrolls out of view, and when the tab
   is hidden — the same discipline as the brand-intro stack.
   ============================================================ */
(function () {
  var roots = document.querySelectorAll('[data-hero-slides]');
  if (!roots.length) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  Array.prototype.forEach.call(roots, function (root) {
    var slides = root.querySelectorAll('[data-hero-slide]');
    if (slides.length < 2) return;
    var dots = root.querySelectorAll('[data-hero-dot]');
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 5000;
    var i = 0, timer = null, paused = false, visible = true;

    function paint() {
      Array.prototype.forEach.call(slides, function (s, n) {
        var on = n === i;
        s.classList.toggle('is-active', on);
        if (on) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
        var link = s.querySelector('.v15hero__link');
        if (link) { if (on) link.removeAttribute('tabindex'); else link.setAttribute('tabindex', '-1'); }
      });
      Array.prototype.forEach.call(dots, function (d, n) {
        d.classList.toggle('is-active', n === i);
        d.setAttribute('aria-selected', n === i ? 'true' : 'false');
      });
    }

    function go(n) { i = (n + slides.length) % slides.length; paint(); }

    function start() {
      stop();
      if (reduce || paused || !visible) return;
      timer = setInterval(function () { go(i + 1); }, interval);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function restart() { go(i); start(); }

    var prev = root.querySelector('[data-hero-prev]');
    var next = root.querySelector('[data-hero-next]');
    if (prev) prev.addEventListener('click', function () { go(i - 1); start(); });
    if (next) next.addEventListener('click', function () { go(i + 1); start(); });
    Array.prototype.forEach.call(dots, function (d, n) {
      d.addEventListener('click', function () { go(n); start(); });
    });

    root.addEventListener('mouseenter', function () { paused = true; stop(); });
    root.addEventListener('mouseleave', function () { paused = false; start(); });
    root.addEventListener('focusin', function () { paused = true; stop(); });
    root.addEventListener('focusout', function () {
      if (!root.contains(document.activeElement)) { paused = false; start(); }
    });

    /* Swipe: a horizontal drag of 40px+ that beats the vertical delta. */
    var x0 = null, y0 = null;
    root.addEventListener('touchstart', function (e) {
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { go(dx < 0 ? i + 1 : i - 1); start(); }
      x0 = y0 = null;
    }, { passive: true });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        if (visible) start(); else stop();
      }, { threshold: 0.2 }).observe(root);
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });

    paint();
    start();
  });
})();

/* ============================================================
   Shop with Total Confidence (v16-confidence)
   Pill pagination — one dot per reachable snap stop, so the last
   dot is the last position that still shows whole cards — and a
   <dialog> that shows the full policy copy of the clicked card.
   ============================================================ */
(function () {
  var roots = document.querySelectorAll('[data-v16-conf]');
  if (!roots.length) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  Array.prototype.forEach.call(roots, function (root) {
    var vp = root.querySelector('[data-conf-viewport]');
    var dotsBox = root.querySelector('[data-conf-dots]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('.v16conf__card'));
    var modal = root.querySelector('[data-conf-modal]');
    var content = root.querySelector('[data-conf-content]');
    if (!vp || !cards.length) return;

    function step() {
      var gap = parseFloat(getComputedStyle(cards[0].parentElement).columnGap) || 0;
      return cards[0].getBoundingClientRect().width + gap;
    }
    function perView() {
      return Math.max(1, Math.round((vp.clientWidth + 1) / step()));
    }
    var dots = [];
    function buildDots() {
      var stops = Math.max(1, cards.length - perView() + 1);
      if (dots.length === stops) return;
      dotsBox.innerHTML = '';
      dots = [];
      if (stops < 2) return;
      for (var i = 0; i < stops; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'v16conf__dot';
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-label', 'Position ' + (i + 1) + ' of ' + stops);
        (function (n) {
          b.addEventListener('click', function () {
            vp.scrollTo({ left: n * step(), behavior: reduce ? 'auto' : 'smooth' });
          });
        })(i);
        dotsBox.appendChild(b);
        dots.push(b);
      }
      sync();
    }
    function sync() {
      if (!dots.length) return;
      var i = Math.min(dots.length - 1, Math.round(vp.scrollLeft / step()));
      dots.forEach(function (d, n) {
        d.classList.toggle('is-active', n === i);
        d.setAttribute('aria-selected', n === i ? 'true' : 'false');
      });
    }
    vp.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', buildDots);
    buildDots();

    /* Dialog */
    if (!modal || !content || typeof modal.showModal !== 'function') return;
    var opener = null;
    function close() {
      if (modal.open) modal.close();
    }
    modal.addEventListener('close', function () {
      document.documentElement.style.overflow = '';
      if (opener) { opener.focus({ preventScroll: true }); opener = null; }
    });
    root.querySelectorAll('[data-conf-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tpl = root.querySelector('template[data-conf-detail="' + btn.getAttribute('data-conf-open') + '"]');
        if (!tpl) return;
        content.innerHTML = '';
        content.appendChild(tpl.content.cloneNode(true));
        var t = content.querySelector('.v16conf__mtitle');
        if (t) modal.setAttribute('aria-label', t.textContent.trim());
        opener = btn;
        document.documentElement.style.overflow = 'hidden';
        modal.showModal();
        modal.scrollTop = 0;
      });
    });
    var x = modal.querySelector('[data-conf-close]');
    if (x) x.addEventListener('click', close);
    /* A click on the backdrop lands on the dialog element itself. */
    modal.addEventListener('click', function (e) {
      if (e.target !== modal) return;
      var r = modal.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) close();
    });
  });
})();
